import { useReducer, useMemo } from 'react';
import { TreeData } from 'components/GenericTree';
import { normalize } from '../utils';
import reducer from './reducer';
import {
  collapse,
  expand,
  filter,
  rename,
  setEdit,
  deleteNode,
  setTree,
  resetSearch,
} from './actions';
import { ApiItem, ItemId } from '../types';

const initialState = {
  tree: { rootId: {}, items: {} },
  data: [],
  filteredTree: undefined,
  loading: false,
};

type ReturnValue = [
  {
    tree: TreeData;
    filteredTree?: TreeData;
  },
  {
    collapse: (id: ItemId) => void;
    expand: (id: ItemId) => void;
    filter: (query: string) => void;
    rename: (id: ItemId, value: string) => void;
    resetSearch: () => void;
    setEdit: (id: ItemId, value: boolean) => void;
    setTree: (newTree: TreeData) => void;
    deleteNode: (id: ItemId) => void;
  },
];

const useTree = (input: ApiItem[]): ReturnValue => {
  const [{ tree, filteredTree }, dispatch] = useReducer(reducer, {
    ...initialState,
    data: input,
    tree: useMemo(() => normalize(input.sort()), [input]),
  });

  return [
    { tree, filteredTree },
    {
      collapse: (id: ItemId) => dispatch(collapse(id)),
      expand: (id: ItemId) => dispatch(expand(id)),
      filter: (query: string) => dispatch(filter(query)),
      rename: (id: ItemId, value: string) => dispatch(rename(id, value)),
      resetSearch: () => dispatch(resetSearch()),
      setEdit: (id: ItemId, value: boolean) => dispatch(setEdit(id, value)),
      setTree: (newTree: TreeData) => dispatch(setTree(newTree)),
      deleteNode: (id: ItemId) => dispatch(deleteNode(id)),
    },
  ];
};

export default useTree;
